export default "__VITE_ASSET__MipMv6VV__"